import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { GroupedStaffList } from '@/types/settings-api';

/**
 * Staff list for the Staff tab (PROD-765).
 * GET /api/Staff/StaffList?OrganizationId={id}&Archive={bool}
 *
 * Returns staff grouped by role (Flutter `GroupedStaffList`). The Staff tab
 * UI flattens the inner `staffList` arrays for display but the group label
 * is used in the section headers.
 */
export function useStaffList(
  organizationId: string | null | undefined,
  archived: boolean,
) {
  return useQuery({
    queryKey: ['settings', 'staff-list', organizationId, archived],
    queryFn: ({ signal }) => {
      if (!organizationId) throw new Error('useStaffList called without orgId');
      const qs = new URLSearchParams({
        OrganizationId: organizationId,
        Archive: String(archived),
      });
      return get<GroupedStaffList[]>(`/api/Staff/StaffList?${qs.toString()}`, { signal });
    },
    enabled: !!organizationId,
  });
}
